import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import MoneyInput from '../../common/MoneyInput';
import { otherLivingExpenseTotal } from '../../../services/individualAffordability';

export default function OtherLivingCostFields() {
  const { control, setValue } = useFormContext();
  const financial = useWatch({control, name:'financial'});
  const otherItems: { name:string; amount?:number }[] | undefined = financial?.otherLivingExpenseItems;
  const itemised = otherItems != null, otherTotal = otherLivingExpenseTotal(financial);
  return (
      <fieldset className="mb-4"><legend className="h6">Other living costs</legend>
        <p className="small text-muted">Name monthly household costs not already captured above. These rows make up Other Living Costs;
          exclude maintenance and debt repayments entered separately.</p>
        {!itemised ? <>
          <p className="small text-muted">A named breakdown has not been recorded. The existing total remains unchanged until you itemise it.</p>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setValue('financial.otherLivingExpenseItems',
            [{ name: '', amount: financial?.otherLivingExpenses }], { shouldDirty: true })}>Add other living costs</button>
        </> : <>
          {(otherItems || []).map((row, index) => <div className="row g-2 mb-2 align-items-end" key={index}>
            <div className="col-md-6"><label htmlFor={`other-cost-name-${index}`}>Other living cost name {index + 1}</label>
              <input id={`other-cost-name-${index}`} className="form-control" maxLength={255} value={row.name || ''}
                onChange={event => setValue('financial.otherLivingExpenseItems', (otherItems || []).map((item, i) =>
                  i === index ? { ...item, name: event.target.value } : item), { shouldDirty: true })} /></div>
            <div className="col-md-4"><label htmlFor={`other-cost-amount-${index}`}>Other living cost amount {index + 1} (R / month)</label>
              <MoneyInput id={`other-cost-amount-${index}`} min="0" step="0.01" className="form-control" value={row.amount}
                onValueChange={amount => setValue('financial.otherLivingExpenseItems', (otherItems || []).map((item, i) =>
                  i === index ? { ...item, amount } : item), { shouldDirty: true })} /></div>
            <div className="col-md-2"><button type="button" className="btn btn-sm btn-link text-danger" aria-label={`Remove other cost ${index + 1}`}
              title={`Remove other cost ${index + 1}`} onClick={() =>
              setValue('financial.otherLivingExpenseItems', (otherItems || []).filter((_, i) => i !== index), { shouldDirty: true })}>
              <i className="fa fa-times" aria-hidden="true" /></button></div>
          </div>)}
          {otherTotal === undefined && <p role="alert" className="text-danger">Complete every other living cost name and non-negative monthly amount to cents.</p>}
          {otherItems?.length === 0 && <p className="small text-muted">No other living costs recorded; subtotal R 0.00.</p>}
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setValue('financial.otherLivingExpenseItems',
            [...(otherItems || []), { name: '' }], { shouldDirty: true })}>Add another living cost</button>
        </>}
      </fieldset>
  );
}
